/**
 * GraphQLWidgetsPage - Real-time GraphQL data visualization
 *
 * Surfaces the GraphQLDashboardWidgets from @ferp/workflow-forms for admin/architect users.
 * Provides GraphQL query visualization and real-time subscription monitoring.
 *
 * Route: /admin/graphql-widgets
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconBrandGraphql } from '@tabler/icons-react';

import { GraphQLLifecycleDashboard } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function GraphQLWidgetsPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="pink">
            <IconBrandGraphql size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>GraphQL Widgets</Title>
            <Text size="sm" c="dimmed">
              Real-time GraphQL query visualization and subscription monitoring
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <GraphQLLifecycleDashboard />
    </Container>
  );
}

export default GraphQLWidgetsPage;
